import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  previewContainer: {
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(2),
    maxWidth: "40%",
    borderLeft: "4px solid #ccc",
    paddingLeft: theme.spacing(2),
  },
  previewImage: {
    width: "160px",
    height: "90px",
    objectFit: "cover",
    borderRadius: theme.shape.borderRadius,
  },
  previewTitle: {
    fontWeight: "bold",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    maxWidth: "100%",
  },
  previewDescription: {
    color: theme.palette.text.secondary,
    maxWidth: "100%",
    fontSize: "0.8em",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  previewTitleLink: {
    color: "#0070f3",
    textDecoration: "none",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "color 0.3s ease",
    "&:hover, &:focus": {
      color: "#0056b3",
      textDecoration: "underline",
    },
  },
}));
